import { config as customConfig } from "../../config/Constants";
import { reportConfig } from "../config/tableReportConfig";
import { getDynamicSelectData } from "../api/data";
import { getSelectData } from "../api/data";
import Cookies from 'js-cookie';
import Axios from "axios";

export const getDownload = async(chartId) => {
    switch(chartId) {
        case 13: {
            const multipleOffender = await getSelectData({
                selectValues: '*', 
                tableName: 'REPORT.ADDRESS_CORRECTION_MULTIPLE_OFFENDER_DOWNLOAD',
                whereField: 'Customer', whereValue: Cookies.get('cp-cn'), db: 'SF'
            });
        
            const details = await getSelectData({
                selectValues: '*', tableName: 'REPORT.ADDRESS_CORRECTION_DETAILS',
                whereField: 'Customer', whereValue: Cookies.get('cp-cn'), db: 'SF'
            });

            return [{ 
                'Multiple Offender Summary': multipleOffender, 
                'Address Correction Detail': details
            }, {
                'name': 'Address Corrections'
            }]
        } 
        default:
          return 'error';
    }
}

export const getDownloadData = async (reportName) => {
   if (Cookies.get("cp-cn") !== "GTMS-CP") {
    const key = (reportConfig[reportName?.toLowerCase()]?.getDownloadData || reportName).toLowerCase();
    const localConfig = reportConfig[key];

    return await getDynamicSelectData({
      selectValues: localConfig.selectValues,
      tableName: localConfig.tableName,
      whereField: localConfig.whereField,
      whereOperators: localConfig.whereOperators,
      whereValue: localConfig.getWhereValue(),
      orderBy: localConfig.orderBy,
      db: localConfig.db,
    });
  }

  const response = await Axios.get(customConfig.url.GET_REPORT, {
    params: {
      reportName,
      companyName: Cookies.get("cp-cn"),
    },
  });

  return response.data.report;
};